import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class HasStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.getKeyStructuredStorage({ type: this.type, keyType: this.keyType, knownKeyType: this.knownKeyType }));
        sb.emitHelper(node, options, sb.helpers.getStorage);
        sb.emitHelper(node, options, sb.helpers.handleUndefinedStorage({
            handleUndefined: () => {
                sb.emitPushBoolean(node, false);
                sb.emitHelper(node, options, sb.helpers.wrapBoolean);
            },
            handleDefined: () => {
                sb.emitOp(node, 'DROP');
                sb.emitPushBoolean(node, true);
                sb.emitHelper(node, options, sb.helpers.wrapBoolean);
            },
        }));
    }
}

//# sourceMappingURL=HasStructuredStorageHelper.js.map
